/**
 * 判断URL是否是合法的HTTP URL
 * */
export function isValidURL(url: string): boolean {
  try {
    new URL(url)
    return true
  } catch (_) {
    return false
  }
}

export function buildCanonicalFormNameByWindowHref(): string {
  const href = window.location.href
  const url = new URL(href)
  const pathname = url.pathname // like: /en/feedback
  const pathnameSegments = pathname.split('/').filter(Boolean)
  // remove locale from pathnameSegments
  const pathnameSegmentsWithoutLocale = pathnameSegments.slice(1)
  const firstPathnameSegment = pathnameSegmentsWithoutLocale[0] // like contact-us
  const canonicalPathname = firstPathnameSegment
    .split('-')
    .map((text) => [text.charAt(0).toUpperCase(), text.slice(1)].join(''))
    .join(' ')
    .trim()
  return canonicalPathname
}
